import React from 'react';
import Moment from 'moment';
import parse from 'html-react-parser';
// Zustand
import { useStore } from '../../zustand';
// Icons
import { ReactComponent as Checkmark } from "../../assets/icons/checkmark.svg"
import { ReactComponent as IconStar } from "../../assets/icons/star.svg";
import { ReactComponent as Arrow } from "../../assets/icons/left_arrow.svg";
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

export default function ReviewItem(props) {
    const { author, date, score, title, content, verified, index } = props;
    const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const classes = useStyles(dynamic_text_settings);
    const billboard_review_mobile = React.useRef(0)
    Moment.locale('en');
    const display_date = Moment(date).format('MM/DD/YY');
    // var is_mobile_device = false;
    // if (device === 'mobile') is_mobile_device = true;

    const _displayStarRating = (score) => {
        let content = [];
        for (let i = 0; i < score; i++) {
          content.push(<IconStar className={`${classes.icon_star} ${classes.full_star}`} key={i} />);
        }
        return content;
    }

    const _displayCheckMark = (verified) => {
        let content = '';
        if (verified) content = <span><Checkmark /> verified reviewer</span>;
        return content;
    }

    const _handleReviewClose = () => {
        let billboardReview = billboard_review_mobile.current;
        if (billboardReview.classList.contains('collapsed')) {
            billboardReview.classList.remove('collapsed');
        } else {
            billboardReview.classList.add('collapsed');
        }
    }

    if(origin === 'static') return null;

    return(
        <div className={`${classes.review} ${index > 0 ? 'collapsed' : ''}`} ref={billboard_review_mobile}>
            <div className={classes.review_author}>
                <span>{author}</span> | { _displayCheckMark(verified) } {verified ? ' | ' : ''}<span>{display_date}</span>
            </div>
            <div className={classes.reviews_bottom_line}>
                {_displayStarRating(score)}
                <Arrow className={`${classes.billboard_info_close} ${classes.billboard_reviews_close}`} onClick={() => _handleReviewClose()}/>
            </div>
            <div className={classes.review_body}>
                <h3>{parse(title)}</h3>
                <p className={classes.review_content}>{parse(content)}</p>
                {/*<p><strong>Describe your service or delivery experience:</strong> It arrived very quickly. I did use customer service and they answered my questions to the best of their ability.</p>*/}
                <p><strong>Bottom Line:</strong> Yes. I would recommend this to a friend.</p>
            </div>
        </div>
    )
}